//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'

import { Navigate, Route, Routes } from 'react-router-dom'

import WidthLimited from '@react/components/WidthLimited'
import LenderPoolOpenings from '@react/lender/LenderPoolOpenings'
import UnconnectedPoolDetails from './UnconnectedPoolDetails'
import { TopAppBar } from '@react/topbar/TopAppBar'

export default function UnconnectedRouting(props: { transferLocation?: string }): React.ReactElement {
  const theme = useTheme()

  return (
    <Box
      data-testid="Unconnected"
      sx={{ height: '100%', width: '100%', backgroundColor: theme.palette.background.canvas }}
    >
      <TopAppBar></TopAppBar>
      {props.transferLocation && (
        <>
          <a href={`https://${props.transferLocation}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div>
              <Typography> Incorrect user role Disconnect and reconnect with a different account or </Typography>
              <Typography> Use url {props.transferLocation} </Typography>
            </div>
          </a>
        </>
      )}

      <Routes>
        <Route
          path="/"
          element={
            <WidthLimited>
              <LenderPoolOpenings limit={4} />
            </WidthLimited>
          }
        />

        <Route
          path="/pools"
          element={
            <WidthLimited>
              {' '}
              <LenderPoolOpenings limit={4} />
            </WidthLimited>
          }
        />

        <Route
          path="/pools/:poolAddr"
          element={
            <WidthLimited>
              <UnconnectedPoolDetails />
            </WidthLimited>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  )
}
